const Mn = require('backbone.marionette');
const Template = require('common/ui/template/signin.hbs');
const LoginButtonsView = require('common/ui/view/login-buttons');

module.exports = Mn.View.extend({
    className: 'jumbotron',
    template: Template,

    regions: {
        loginButton: '.login-buttons'
    },

    onRender: function () {
        this.showChildView('loginButton', new LoginButtonsView());
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/signin.js